import { FC } from "react";
import { TableCell, TableHeadCell } from "@rothoblaas/design-system";
import AdminCrudTable from "../../../../components/ui/AdminCrudTable";
import useI18n from "../../../../hooks/useTranslations";
import { FasteningType } from "../../../../http/deckDesigner/types/fasteningTypes";
import useDeckFasteningTypesApi from "../../../../http/deckDesigner/useFasteningTypes";
import FasteningTypeForm from "./FasteningTypeForm";

const AdminFasteningTypes: FC = () => {
  const i18n = useI18n();
  const fasteningTypesApi = useDeckFasteningTypesApi();

  return (
    <AdminCrudTable<FasteningType>
      filterPrefix="fastening_types"
      useList={fasteningTypesApi.useDeckFasteningTypes}
      head={
        <>
          <TableHeadCell align="left">{i18n.translation.common.name}</TableHeadCell>
          <TableHeadCell align="left">{i18n.translation.deckDesignerModule.groovingTypes.plural}</TableHeadCell>
        </>
      }
      renderRow={(item) => (
        <>
          <TableCell>{item.name}</TableCell>
          <TableCell>{item.groovingTypes.map((groovingType) => groovingType.name).join(", ")}</TableCell>
        </>
      )}
      renderForm={(item, onClose) => <FasteningTypeForm fasteningType={item} onClose={onClose} />}
    />
  );
};

export default AdminFasteningTypes;
